import Vue from "vue"
import axios from "@/axios";
import Responses from "@/common/pagination/entities/responses";
import Dish from "@/models/Dish";
import DishCategory from "@/models/DishCategory";
import PaginationResponse from "@/common/pagination/entities/pagination-response";
import DishesRequestFilter from "@/models/DishesRequestFilter";
import BaseService from "./base-service";

class DishesService extends BaseService {
  public async findAllCategoriesAsync() {
    const res = await axios.post<PaginationResponse<DishCategory>>(
      `dishcategory/?api_key=${Vue.prototype.$apiKey}`
    );
    return Responses.pagedList(res);
  }

  public async findOneCategoryAsync(id: string | null) {
    if (id === null) {
      return null;
    }
    const res = await axios.get<Dish>(
      `dishcategory/?api_key=${Vue.prototype.$apiKey}&uid=${id}`
    );
    return Responses.obj(res);
  }

  public async findAllAsync(categoryId: number) {
    const res = await axios.get<PaginationResponse<Dish>>(
      `dish/?api_key=${Vue.prototype.$apiKey}&dishcategory=${categoryId}`
    );
    return Responses.pagedList(res);
  }

  public async updateDisabled(id: string, disabled: number) {
    const res = await axios.put(
      `dish/?api_key=${Vue.prototype.$apiKey}&uid=${id}`,
      { disabled: disabled }
    );
    return Responses.obj(res);
  }
}

export default new DishesService();
